import useProject from '@hooks/useProject';
import { useTranslation } from 'react-i18next';

function usePriceUnit() {
    const { i18n } = useTranslation();
    const { language } = i18n;
    const project = useProject();
    switch (project?.serviceCountry) {
    case 'JP': return ' 円 ';
    default: return language === 'en' ? 'KRW' : '원';
    }
}

export default usePriceUnit;
